package com.taager.firebase.di

import org.kodein.di.DI

object FirebaseDI {
    val module = DI.Module("Firebase DI") {
        import(InternalFirebaseDI.module)
    }
}
